export const ActionTypes = {
  LOADING: "ADD_OPTION_ROWS_LOADING",
  ERROR: "ADD_OPTION_ROWS_ERROR",
  SUCCESS: "ADD_OPTION_ROWS_SUCCESS",
};
